import type { InfraControlPlaneCredentialRef } from './infraSecrets';

/** Portable runtime target state contains credential identity only, never resolved values. */
export type InfraComputeTarget = {
  readonly id: string;
  readonly os: 'linux' | 'darwin' | 'windows';
  readonly architecture: 'amd64' | 'arm64';
} & (
  | { readonly kind: 'local-host' }
  | {
      readonly kind: 'ssh-host';
      readonly host: string;
      readonly port: number;
      readonly user: string;
      readonly credential: InfraControlPlaneCredentialRef;
      /** Expected host key supplied by the compute owner; runtimes must verify host authenticity. */
      readonly hostKeyFingerprint: string;
    }
);
